<!--  -->
<template>
<div :class="['Index',isMobile?'mbg':'bg']">
    <img src="@/assets/img/Index/logo.png" alt="" class="logo">
    <img src="@/assets/img/Index/title.png" alt="" class="title" v-if="!isMobile">
    <img src="@/assets/img/Index/mtitle.png" alt="" class="title" v-else>
    <img src="@/assets/img/Index/info.png" alt="" class="info" v-if="!isMobile">
    <img src="@/assets/img/Index/minfo.png" alt="" class="info" v-else>
    <img src="@/assets/img/Index/flower.png" alt="" class="flower" v-if="!isMobile">
    <img src="@/assets/img/Index/mflower.png" alt="" class="mflower" v-else>
    <div class="btns">
        <img src="@/assets/img/Index/btn1.png" alt="" class="btn1" @click="$router.push({name:'Home',params:{id:'1'}})">
        <img src="@/assets/img/Index/btn2.png" alt="" class="btn2" @click="$router.push('/game')">
    </div>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import browser from '@/utils/browser.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    isMobile:browser.mobile,
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .Index {
        width:100%;
        height:100%;
        &.bg {
            background:url(../assets/img/Index/bg.jpg)center/100% no-repeat;
            background-size:cover;
        }
        .logo {
            width:19vw;
            position:absolute;
            top:5vh;
            left:2vw;
        }
        .title {
            width:29vw;
            position:absolute;
            left:12vw;
            top:20vh;
        }
        .flower {
            position:absolute;
            bottom:0;
            right:10vw;
        }
        .info {
            position:absolute;
            bottom:3vh;
            left:10vw;
        }
        .btns {
            position:absolute;
            left:5vw;
            bottom:22vh;
            img {
                width:9vw;
                margin:0 4vw;
                cursor:pointer;
            }
        }
        &.mbg {
            background:url(../assets/img/Index/mbg.jpg)center/100% no-repeat;
            .logo {
                width:41vw;
                top:5vw;
                left:5vw;
            }
            .mflower {
                position:absolute;
                width:87vw;
                right:2vw;
                bottom:15vh;
            }
            .title {
                width:75vw;
                top:10vh;
            }
            .info {
                width:87vw;
                left:0;
                right:0;
                bottom:2vh;
                margin:auto;
            }
            .btns {
                width:100%;
                display:flex;
                justify-content:center;
                bottom:12vh;
                left:0;
                right:0;
                margin:auto;
                img {
                    width:26vw;
                    margin:0 10vw;
                }
            }
        }
    }
</style>